import { createContext } from "react";
import { LanguageProviderState } from "./language.types";

const initialState: LanguageProviderState = {
  language: "en-US",
  setLanguage: () => null,
};

const LanguageProviderContext =
  createContext<LanguageProviderState>(initialState);

export default LanguageProviderContext;
